<script lang="ts">
  import {onDestroy} from "svelte";
  import SuggestionListItem from "./SuggestionListItem.svelte";
  import {SqrlTestId} from "../../../constants/squirrel";
  import {keywords} from "../../../store/SuggestionStore";
  import {timeSuggest, timeSuggestRender} from "../../../times/TimeFactory";
  import {indexStore} from "../../../store/IndexStore";

  const unsubscribe = keywords.subscribe((value) => {
    indexStore.updateMaxIndex(value.length);
  });
  timeSuggest.mark();

  timeSuggestRender.measure();

  onDestroy(() => {
    timeSuggest.measure();
    unsubscribe();
  })
</script>

<div class="squirrel_searchSuggestions pl_table-view" data-testid={SqrlTestId.SUGGESTION_LIST}>
    <ul class="squirrel_searchSuggestions__list squirrel_border_top">
        {#each $keywords as suggestion, index}
            <SuggestionListItem on:sendRequest {index} {suggestion}/>
        {/each}
    </ul>
</div>

<style lang="scss">
  @use "~@otto-ec/global-frontend-settings/scss/pl_variables" as pl_variables;

  .squirrel_searchSuggestions {
    background-color: pl_variables.$pl_color-white100;
    padding: 0;
    border-radius: 0 0 8px 8px;

    .squirrel_border_top {
      border-top: 4px pl_variables.$pl_color-grey25 solid;
    }
  }
</style>
